import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";

export default function useConfig() {
  const store = useStore();

  const updateObject = ref({});
  const course = ref(null);
  const showConfirmModal = ref(false);

  const config = computed(() => store.getters["utilities/getConfig"]);
  const loading = computed(() => store.getters["utilities/isLoading"]);
  const updating = computed(() => store.getters["utilities/isUpdating"]);
  const error = computed(() => store.getters["utilities/getErrors"]);
  const success = computed(() => store.getters["utilities/getSuccessStatus"]);

  const isUpdateObjectEmpty = computed(
    () => Object.keys(updateObject.value).length === 0
  );

  watch(error, (newError) => {
    if (newError) {
      store.dispatch("toastNotification/displayToast", {
        message: newError,
        type: "error",
      });
    }
  });

  watch(success, (newStatus) => {
    if (newStatus) {
      store.dispatch("toastNotification/displayToast", {
        message: "Course configuration updated successfully.",
        type: "success",
      });
    }
  });

  watch(course, async (newCourse) => {
    if (newCourse) {
      await store.dispatch("utilities/fetchConfig", newCourse.id);
    }
  });

  const updateFieldObject = (fieldName, value) => {
    if (value) {
      if (value === "true" || value === true) {
        updateObject.value[fieldName] = true;
      } else if (value === "false" || value === false) {
        updateObject.value[fieldName] = false;
      } else {
        updateObject.value[fieldName] = value;
      }
    } else {
      delete updateObject.value[fieldName];
    }
  };

  const handleSaveClick = () => {
    showConfirmModal.value = true;
  };

  const updateConfig = (sendDevices) => {
    const params = {
      payload: updateObject.value,
      courseId: course.value.id,
      sendDevices: sendDevices || false,
    };
    const result = store.dispatch("utilities/updateConfig", params);
    if (result && result.success) {
      updateObject.value = {};
    }
  };

  onMounted(async () => {
    await store.dispatch("timezones/fetchTimezones");
  });

  return {
    showConfirmModal,
    course,
    config,
    updateFieldObject,
    updateConfig,
    handleSaveClick,
    isUpdateObjectEmpty,
    updating,
    loading,
    success,
    error,
  };
}
